import { ShopRendererApiClient } from '@fourthwall/services/dist/ShopRendererApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useShopRendererDataQuery = createQueryHook(ShopRendererApiClient.getShop, {
  queryKey: ['shopRendererData'],
})
